import { render, staticRenderFns } from "./VBoard.vue?vue&type=template&id=40d393e8&scoped=true&"
import script from "./VBoard.vue?vue&type=script&lang=js&"
export * from "./VBoard.vue?vue&type=script&lang=js&"
import style0 from "./VBoard.vue?vue&type=style&index=0&id=40d393e8&scoped=true&lang=scss&"
import style1 from "./VBoard.vue?vue&type=style&index=1&id=40d393e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d393e8",
  null
  
)

export default component.exports